import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureIsOn } from 'src/common/growthbook';
import type { UserData } from 'src/common/interfaces';
import { useGetUserQuery } from 'src/common/slices';
import { useGetPublicProfileGeneralDataQuery } from 'src/features/public-profile/public-profile.slice';
import { checkIfPathMatches } from '../campaigns/helpers';
import { useShouldShowInviteElement } from './hooks/use-should-show-invite-banner';
import * as Styled from './invite-banner.styles';
import { INVITE_LOCAL_STORAGE_KEY } from './invite-page';
const PATHS_TO_EXCLUDE = ['/pricing', '/welcome', '/payment/pending', '/feedback/subscription', '/room/*', '/echo', '/path/outline/*', '/recapme/*', '/certification/*', '/soc-sim/*', '/pre-signup', '/pre-signup-welcome', '/ttx', '/hacktivities', '/challenges', '/ttx/*'];
type InviteElementProps = {
  user?: UserData['user'];
};
export const InviteTopBar = ({
  user
}: InviteElementProps) => {
  const {
    pathname
  } = useLocation();
  const isInviteEnabled = useFeatureIsOn('invite-followers');
  const {
    shouldShowElement
  } = useShouldShowInviteElement(user?.username);
  const [isDismissed, setIsDismissed] = useState(false);
  const isUndesiredPath = ['/manage-account/subscription', '/manage-account/subscription/billing'].includes(pathname);
  const isElementVisible = shouldShowElement && !isUndesiredPath;
  const inviterUsername = localStorage.getItem(INVITE_LOCAL_STORAGE_KEY);
  const {
    data: userResponse
  } = useGetUserQuery();
  const {
    data: publicProfileData
  } = useGetPublicProfileGeneralDataQuery({
    username: inviterUsername ?? ''
  }, {
    skip: !isElementVisible || !inviterUsername
  });
  const publicProfile = publicProfileData?.data;
  const isUserLoggedIn = !!userResponse?.data?.user;
  if (!isInviteEnabled || !isElementVisible || isUserLoggedIn || !publicProfile?.avatar || isDismissed) return null;
  const pathsToInclude = ['/*'];
  const pathMatches = checkIfPathMatches(PATHS_TO_EXCLUDE, pathsToInclude, pathname);
  if (!pathMatches) return null;
  const displayName = publicProfile.username || 'Your friend';
  const avatarUrl = publicProfile.avatar;
  const handleDismiss = () => {
    setIsDismissed(true);
  };
  return <Styled.Bar role="region" aria-label="Friend Invite" data-sentry-element="unknown" data-sentry-component="InviteTopBar" data-sentry-source-file="invite-banner.tsx">
      <Styled.CopyAndIconWrapper data-sentry-element="unknown" data-sentry-source-file="invite-banner.tsx">
        <Styled.InviterIcon src={avatarUrl} alt={`${displayName}'s profile picture`} width={32} height={32} data-sentry-element="unknown" data-sentry-source-file="invite-banner.tsx" />
        <p>
          <Styled.Username data-sentry-element="unknown" data-sentry-source-file="invite-banner.tsx">{displayName}</Styled.Username> has invited you to learn on TryHackMe. Join for free to get
          started!
        </p>
      </Styled.CopyAndIconWrapper>
      <Styled.CloseButton onClick={handleDismiss} aria-label="Dismiss invite banner" data-sentry-element="unknown" data-sentry-source-file="invite-banner.tsx">
        <FontAwesomeIcon icon={faXmark} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="invite-banner.tsx" />
      </Styled.CloseButton>
    </Styled.Bar>;
};